export default __webpack_public_path__ + "static/media/icons8-video-conference-100.2fe7eb44.svg";